import React from "react";
import Typography from "@mui/material/Typography";

function CodeofConduct() {  
  return (
    <div className="ABOUTmainContainer">
      <div className="allRightContent">
        <div className="textContainer">
          <h4 style={{ fontWeight: "bold" }}>
            Code of Conduct
          </h4>
          <Typography>
          <p>
            The registration of a Ph.D. scholar may be cancelled by the Director, Research & Development,
             JNTU-GV, if the candidate fails to satisfy the conditions stipulated in the admission order or violates
              the rules and regulations of Ph.D. after giving notice to the concerned candidate. The Director, Research & Development,
               JNTU-GV, may cancel the registration of a Ph.D. scholar on the recommendation of the supervisor and/or Doctoral Research
                Committee (DRC) under the following circumstances after giving notice to the candidate:
            </p>

          </Typography>
          <Typography>
          <ul>
              <li>During their research period at JNTU-GV, scholars are prohibited from registering for any other courses at any other University or Institution leading to the award of a degree. Any ambiguity in this regard will result in forfeiture of admission at JNTU-GV.</li>
              <li>In any communication addressed to the Director of Research & Development at JNTU-GV, the signatures of the Research Supervisor and/or co-supervisor are necessary and mandatory. The decision of the Vice-Chancellor at JNTU-GV regarding the allotment of Research Supervisors is final.</li>
              <li>In case of conflict between a Research Scholar and Supervisor/Co-Supervisor, the decision of the University regarding a change of Supervisor/Co-Supervisor is final. 
                Research Scholars at JNTU-GV are expected to actively engage in original research potentially resulting in Intellectual Property Rights (IPR) and patents.</li>
              <li>Any doubts or ambiguities in the interpretation of these rules will be resolved by the Vice-Chancellor at JNTU-GV, whose decision will be final. JNTU-GV reserves the right to alter the regulations as and when necessary.</li>
              <li>Violations of the code of conduct, including but not limited to ragging, lack of courtesy, indecent behavior, possession or distribution of alcohol or drugs, adoption of unfair means in examinations, and noisy or unseemly behavior, will result in disciplinary measures commensurate with the gravity of the offense.</li>
              <li>The Head of the Department, Board of Studies (BoS), and the Head of the Unit (Principal/Director) have the authority to enforce discipline. No scholar may receive scholarship/fellowship from more than one source, either Government or Private.</li>
              <li>Fee details, mode of payment, and other related information can be obtained from the Office of Research and Development at JNTU-GV. Fee payment for Full-Time as well as External Candidates is to be completed before the 31st of July every year.</li>
              <li>In the event of Ph.D. registration cancellation, the candidate must clear all due fees for the return of original certificates. Temporary retrieval of original certificates must be authorized by the Director of Research & Development at JNTU-GV and returned within the stipulated time. Upon completion of the Ph.D. degree, 
                no Transfer Certificate will be issued, but a Migration Certificate can be obtained from the Examination Branch of the University.

</li>
              </ul>

            </Typography>
          
        </div>
      </div>
    </div>
  );
}

export default CodeofConduct;
